import { render, staticRenderFns } from "./CarouselContainer.vue?vue&type=template&id=2ba5c44c&"
import script from "./CarouselContainer.vue?vue&type=script&lang=js&"
export * from "./CarouselContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports